import React, { useState } from 'react'
import styles from './MileageSaarathi.module.css';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import Summary_cards from './Summary_cards';
import EnergyEfficiencyCard from './Energyeffstats'



function FleetSummary({ filterdata }) {

    const [summaryValues, setSummaryValues] = useState({});
    // const [apiLoadStatus, setApiLoadStatus] = useState({});


    const summaryCardsData = [
        { title: "Total Vehicles", apiEnd: "mileage_sarathi_ace/fleet_summary_total_vehicle_count", dataKey: "total_vin", tooltip: false, tooltipTxt: "Total vin vehicle" },
        { title: "Mileage Saarathi Vehicles", apiEnd: "mileage_sarathi_ace/fleet_summary_MS_vehicle_count", dataKey: "total_vin", tooltip: false, tooltipTxt: "Total vin" },
        { title: "Offline Vehicles", apiEnd: "mileage_sarathi_ace/fleet_summary_offline_vehicle", dataKey: "Offline_vehicle", tooltip: true, tooltipTxt: "No. of vehicles not connected to the platform" },
        { title: "Low Performing Vehicles", apiEnd: "mileage_sarathi_ace/fleet_summary_low_high_avg_vehicles", dataKey: "low_performing", tooltip: true, tooltipTxt: "No. of EVs getting avg range < 40 percentile of average range distribution of your fleet only" },
        { title: "Average Performing Vehicles", apiEnd: "mileage_sarathi_ace/fleet_summary_low_high_avg_vehicles", dataKey: "average_performing", tooltip: true, tooltipTxt: "No. of EVs getting avg range between 40-60 percentile of average range distribution of your fleet only" },
        { title: "High Performing Vehicles", apiEnd: "mileage_sarathi_ace/fleet_summary_low_high_avg_vehicles", dataKey: "high_performing", tooltip: true, tooltipTxt: "No. of EVs getting avg range > 60 percentile of average range distribution of your fleet only" },
    ];


    const handleSummaryValue = (key, value) => {
        setSummaryValues((prev) => ({
            ...prev,
            [key]: value,
        }));
    };


    const downloadData = () => {
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheettml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        const excelFileName = `Performing Vehicles`;

        const flatData = [{
            'Total Vehicles': summaryValues?.TotalVehicles,
            'Mileage Saarathi Vehicles': summaryValues?.MileageSaarathiVehicles,
            'Offline Vehicles': summaryValues?.OfflineVehicles,
            'Low Performing Vehicles': summaryValues?.LowPerformingVehicles,
            'Average Performing Vehicles': summaryValues?.AveragePerformingVehicles,
            'High Performing Vehicles': summaryValues?.HighPerformingVehicles,
            'Average Energy Efficiency': summaryValues?.Average_Energy_Efficiency + " Wh/km",
            'Target Energy Efficiency': summaryValues?.Target_Energy_Efficiency + " Wh/km",
            'Energy Efficiency Score': summaryValues?.Energy_Efficiency_Score + " Wh/km",

        }]

        const ws = XLSX.utils.json_to_sheet(flatData);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, excelFileName + fileExtension);
    }

    // const handleApiLoaded = (apiKey, isLoaded) => {
    //     setApiLoadStatus((prev) => ({
    //         ...prev,
    //         [apiKey]: isLoaded,
    //     }));
    // };

    const allApisLoaded = Object.values(summaryValues)?.length == 9

    // const allApisLoaded = summaryCardsData.length > 0 &&
    //     Object.values(apiLoadStatus).length === summaryCardsData.length &&
    //     Object.values(apiLoadStatus).every((val) => val === true);

    return (
        <>
            {/* <div className="card mb-3 p-3"> */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className={`m-0 fw-bold ${styles.date_range_selection}`}>Fleet Summary</h6>
                <a href="#" className={`text-decoration-none ${styles.download_button} ${!allApisLoaded ? 'text-muted' : ""}`} style={{ pointerEvents: !allApisLoaded ? "none" : "" }} onClick={(e) => { e.preventDefault(); downloadData(); }}>
                    <i className="fas fa-download me-1"></i>Download Report
                </a>
            </div>
            <div className="row">
                {summaryCardsData.map((item, index) => (<Summary_cards key={index} propsData={item} filterdata={filterdata} onValueUpdate={handleSummaryValue} /* onApiLoaded={handleApiLoaded} */ />))}
            </div>
            <div>
                <EnergyEfficiencyCard filterdata={filterdata} onValueUpdate={handleSummaryValue} /* onApiLoaded={handleApiLoaded} */ />
            </div>
            {/* </div> */}

        </>
    )
}

export default FleetSummary
